import { OptionRecord } from "./OptionRecord";

export const splitMassText = (
  text: string | undefined,
  baseId: number,
): OptionRecord[] => {
  const chunks: string[] =
    text
      ?.split("\n")
      .map((s) => s.trim())
      .filter((s) => !!s) ?? [];
  return chunks.map((label) => ({
    // eslint-disable-next-line no-param-reassign
    id: String(baseId++),
    label,
    order: undefined,
    isDefault: false,
  }));
};
